// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
import { isCanada } from '@tcp/core/src/utils';
import Col from '@tcp/core/src/components/common/atoms/Col';
import FooterNavLinksList from '../../FooterNavLinksList';
import SocialMediaLinks from '../../SocialMediaLinks';
import CountrySelector from '../../../../HeaderNew/molecules/CountrySelector';

const AccordionList = dynamic(() =>
  // eslint-disable-next-line extra-rules/no-commented-out-code
  import(
    // eslint-disable-next-line extra-rules/no-commented-out-code
    /* webpackChunkName: "AccordionList" */ '@tcp/core/src/components/common/molecules/AccordionList'
  )
);

const removeDuplicates = (arr) => {
  return arr.reduce((unique, current) => {
    if (!unique.find((item) => JSON.stringify(item) === JSON.stringify(current))) {
      unique.push(current);
    }
    return unique;
  }, []);
};

const mergeRewardsLinks = (navLinks) => {
  let tmpAry = [];
  let removeIndex = -1;

  navLinks.forEach((navlink, index) => {
    if (navlink.header.url === '/content/myplace-rewards-page') {
      tmpAry = navlink.links;
      removeIndex = index;
    }
    if (navlink.header.url === '/content/place-card') {
      navlink.links.unshift(...tmpAry);
    }
  });

  if (removeIndex !== -1) {
    navLinks.splice(removeIndex, 1);
  }
};

const handleCanadaSpecificLogic = (navLinks) => {
  if (isCanada()) {
    navLinks.splice(1, 1); // Remove the second item for Canada
  }
};

const updateFirstNavLink = (navLinks) => {
  // Create a copy of the navLinks array to avoid modifying the original
  const updatedNavLinks = [...navLinks];

  updatedNavLinks[0] = {
    ...updatedNavLinks[0],
    header: {
      ...updatedNavLinks[0].header,
    },
    links: [...removeDuplicates(updatedNavLinks[0].links)],
  };

  return updatedNavLinks;
};

const FooterMiddleMobile = ({
  className,
  navLinkItems,
  isLoggedIn,
  linkConfig,
  footerActionCreator,
  defaultStore = {},
  fullPageAuthEnabled,
  isFooterRedesignEnabled,
  trackAnalyticsClick,
  links,
  isNavigationFooter,
  updateExpandedState,
  offerZoneState,
}) => {
  if (isFooterRedesignEnabled) {
    const updatedNavLinks = [...navLinkItems];
    if (!isCanada()) {
      mergeRewardsLinks(updatedNavLinks);
    } else {
      handleCanadaSpecificLogic(updatedNavLinks);
    }

    const renderFooterContent = (navLinks) => {
      return (
        <AccordionList
          className={`${className}`}
          accordionItems={navLinks}
          activeIcon="down_arrow_icon"
          inactiveIcon="up_arrow_icon"
          customCls="accordian-head-new"
          updateExpandedState={updateExpandedState}
          offerZoneState={offerZoneState}
        >
          {navLinks.map((item) => (
            <FooterNavLinksList
              key={item.header.title}
              insideAcccordion
              listArray={item.links}
              isLoggedIn={isLoggedIn}
              linkConfig={linkConfig}
              footerActionCreator={footerActionCreator}
              defaultStore={defaultStore}
              fullPageAuthEnabled={fullPageAuthEnabled}
              isFooterRedesignEnabled={isFooterRedesignEnabled}
            />
          ))}
        </AccordionList>
      );
    };

    // Create a shallow copy of the array

    return (
      <Col
        colSize={{
          large: 12,
          medium: 8,
          small: 6,
        }}
        ignoreGutter={{ small: true, medium: true }}
      >
        {renderFooterContent(updateFirstNavLink(updatedNavLinks))}
        <CountrySelector
          showInFooter
          trackAnalyticsClick={trackAnalyticsClick}
          isFooterRedesignEnabled={isFooterRedesignEnabled}
        />
        <SocialMediaLinks
          links={links}
          isFooterRedesignEnabled={isFooterRedesignEnabled}
          isNavigationFooter={isNavigationFooter}
        />
      </Col>
    );
  }
  return (
    <Col
      colSize={{
        large: 12,
        medium: 8,
        small: 6,
      }}
      ignoreGutter={{ small: true, medium: true }}
    >
      <AccordionList className={className} accordionItems={navLinkItems}>
        {/* To hide the second footer column for canada, we need to put check for index ===1 and isCanada */}
        {navLinkItems.map((item, index) =>
          index === 1 && isCanada() ? null : (
            <FooterNavLinksList
              insideAcccordion
              listArray={item.links}
              isLoggedIn={isLoggedIn}
              linkConfig={linkConfig}
              footerActionCreator={footerActionCreator}
              defaultStore={defaultStore}
              fullPageAuthEnabled={fullPageAuthEnabled}
            />
          )
        )}
      </AccordionList>
    </Col>
  );
};

FooterMiddleMobile.propTypes = {
  className: PropTypes.string.isRequired,
  navLinkItems: PropTypes.array.isRequired,
  isLoggedIn: PropTypes.bool,
  linkConfig: PropTypes.shape({
    'track-order': PropTypes.func,
    favorites: PropTypes.func,
    'log-out': PropTypes.func,
    'login-account': PropTypes.func,
    'create-account': PropTypes.func,
  }).isRequired,
  footerActionCreator: PropTypes.func.isRequired,
  defaultStore: PropTypes.shape({}),
  fullPageAuthEnabled: PropTypes.bool,
};

FooterMiddleMobile.defaultProps = {
  isLoggedIn: false,
  defaultStore: {},
  fullPageAuthEnabled: false,
};

export default FooterMiddleMobile;
